import React, { useEffect, useRef, useState } from "react";
import { SelectButton } from "primereact/selectbutton";
import { hasAnswer } from "./assignmentDraft";

export default function QuestionNavigator({ questions, answers, index, review, readOnly, locked, onSelect, onReview }) {
  const [filter, setFilter] = useState("all");
  const activeQuestion = useRef(null);
  const answered = questions.filter(q => hasAnswer(q, answers[q.id])).length;
  const pending = questions.length - answered;
  const percent = questions.length ? Math.round(answered / questions.length * 100) : 0;
  useEffect(() => {
    activeQuestion.current?.scrollIntoView?.({ block: "nearest" });
  }, [index, review, filter]);

  return (
    <nav className="player-navigator" aria-label="Preguntas del cuestionario">
      <div className="player-navigator-heading">
        <h2>Preguntas <span>{questions.length}</span></h2>
        <div className="player-progress-label"><span>{answered} de {questions.length} respondidas</span><strong>{percent}%</strong></div>
        <progress aria-label="Preguntas respondidas" value={answered} max={questions.length || 1} />
        <SelectButton value={filter} onChange={event => setFilter(event.value)} allowEmpty={false}
          aria-label="Filtrar preguntas" options={[{ label: "Todas", value: "all" }, { label: `Pendientes (${pending})`, value: "pending" }]} />
      </div>
      <ol className="player-question-list">
        {questions.map((question, position) => {
          const done = hasAnswer(question, answers[question.id]);
          if (filter === "pending" && done) return null;
          const selected = !review && position === index;
          return (
            <li key={question.id}>
              <button type="button" disabled={locked} ref={selected ? activeQuestion : undefined}
                aria-current={selected ? "step" : undefined}
                aria-label={`Pregunta ${position + 1}: ${question.text}. ${done ? "Respondida" : "Pendiente"}${question.required ? ". Obligatoria" : ""}`}
                className={`player-question-link${done ? " is-answered" : ""}`}
                onClick={() => onSelect(position)}>
                <span className="player-question-number" aria-hidden="true">{position + 1}</span>
                <span className="player-question-link-text"><span title={question.text}>{question.text}</span>
                  <small>{done ? "Respondida" : "Pendiente"}{question.required && " · Obligatoria"}</small>
                </span>
                <i aria-hidden="true" className={`pi ${done ? "pi-check-circle" : "pi-circle"}`} />
              </button>
            </li>
          );
        })}
      </ol>
      {filter === "pending" && !pending && <p className="player-no-pending"><i className="pi pi-check-circle" aria-hidden="true" /> No hay preguntas pendientes.</p>}
      <div className="player-navigator-footer">
        <button type="button" onClick={onReview} disabled={locked || !questions.length} aria-current={review ? "step" : undefined}>
          <i className="pi pi-list-check" aria-hidden="true" />{readOnly ? "Resumen de respuestas" : "Revisar respuestas"}
          <i className="pi pi-arrow-right" aria-hidden="true" />
        </button>
      </div>
    </nav>
  );
}
